import React from "react";
import { Link } from "react-router-dom";

const Header = () => {

  function logoutUser() {
    localStorage.clear();
    window.location.replace('/login');
  }

  return (
    <>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light justify-content-between">

        <ul className="navbar-nav">
          <li className="nav-item">
            <Link
              className="nav-link"
              data-widget="pushmenu"
              to="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </Link>
          </li>
        </ul>

        <a href="#" className="d-md-none">
          <img
            src="../dist/img/logo.webp"
            alt="Superbmytrip Logo"
            width={120}
            className="brand-image m-0"
            style={{
              border: "none"
            }}
          />
        </a>

        <ul className="navbar-nav d-none">

          <li className="nav-item dropdown d-none d-md-block">
            <Link className="nav-link" data-toggle="dropdown" to="#">
              <i className="far fa-bell" />
              <span className="badge badge-warning navbar-badge">15</span>
            </Link>
            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
              <span className="dropdown-item dropdown-header">
                15 Notifications
              </span>
              <div className="dropdown-divider" />
              <Link to="#" className="dropdown-item">
                <i className="fas fa-envelope mr-2" /> 4 new messages
                <span className="float-right text-muted text-sm">3 mins</span>
              </Link>
              <div className="dropdown-divider" />
              <Link to="#" className="dropdown-item">
                <i className="fas fa-users mr-2" /> 8 friend requests
                <span className="float-right text-muted text-sm">12 hours</span>
              </Link>
              <div className="dropdown-divider" />
              <Link to="#" className="dropdown-item">
                <i className="fas fa-file mr-2" /> 3 new reports
                <span className="float-right text-muted text-sm">2 days</span>
              </Link>
              <div className="dropdown-divider" />
              <Link to="#" className="dropdown-item dropdown-footer">
                See All Notifications
              </Link>
            </div>
          </li>

          <li className="nav-item dropdown">
            <Link
              className="nav-link bg-info rounded dropdown-toggle"
              to="#"
              id="navbarVersionDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Profile
            </Link>
            <div
              className="dropdown-menu py-0"
              aria-labelledby="navbarVersionDropdown"
            >
              <a className="dropdown-item py-2 border-bottom" to="#">
                Profile Update
              </a>
              <Link
                className="dropdown-item py-2"
                style={{ cursor: "pointer" }}
                onClick={logoutUser}
              >
                Logout
              </Link>
            </div>
          </li>

        </ul>

      </nav>
    </>
  );
};

export default Header;
